// Libs
import axios from 'axios'
import _ from 'lodash'

// Actions
import { changeLocalLoading, changeErr, changeSuccess } from '../App/actions'
import { signOut } from '../Deauth/actions'
import { reset, change } from 'redux-form'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_PAYMENT_LOADING = 'change_payment_loading'
export const CHANGE_PAYMENT_CASES = 'change_payment_cases'
export const CHANGE_PAYMENT_DATE_INDEX = 'change_payment_date_index'
export const CHANGE_PAYMENT_DATES = 'change_payment_dates'
export const TOGGLE_PAYMENT_VIEW_ALL = 'toggle_payment_view_all'

// Axios Cancelation
export let fetchPaymentCasesCancel

export const changePaymentLoading = (status) => {
  return {
    type: CHANGE_PAYMENT_LOADING,
    payload: status
  }
}

export const changePaymentCases = (cases) => {
  return {
    type: CHANGE_PAYMENT_CASES,
    payload: cases
  }
}

export const changePaymentDateIndex = (dateIndex) => {
  return {
    type: CHANGE_PAYMENT_DATE_INDEX,
    payload: dateIndex
  }
}

export const changePaymentDates = (dates) => {
  return {
    type: CHANGE_PAYMENT_DATES,
    payload: dates
  }
}

export const togglePaymentViewAll = () => {
  return {
    type: TOGGLE_PAYMENT_VIEW_ALL
  }
}

export const fetchPaymentDates = (groupId) => {
  return function (dispatch) {
    dispatch(changePaymentLoading(true))
    return serverAPI.get(`/payment/group/${groupId}`)
      .then(response => {
        dispatch(changePaymentDates(response.data))

        if (!_.isEmpty(response.data)) {
          const { start_date, end_date } = response.data[0]

          const startDate = start_date.substring(0, 4) + start_date.substring(5, 7) + start_date.substring(8, 10)
          const endDate = end_date.substring(0, 4) + end_date.substring(5, 7) + end_date.substring(8, 10)

          dispatch(fetchPaymentCases(null, groupId, startDate, endDate, true))
        } else {
          dispatch(changePaymentLoading(false))
        }
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}

export const fetchPaymentCases = (receiptId, groupId, startDate, endDate, isNewReceipt = false) => {
  let url = `/payment/receipt/${receiptId}`

  if (isNewReceipt) {
    url = `/payment/next-receipt/${groupId}/${startDate}/${endDate}`
  }

  if (fetchPaymentCasesCancel) {
    fetchPaymentCasesCancel()
  }

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      fetchPaymentCasesCancel = c;
    })
  }

  return function (dispatch) {
    dispatch(changePaymentLoading(true))
    serverAPI.get(url, config)
      .then(response => {
        dispatch(changePaymentLoading(false))
        dispatch(changePaymentCases(response.data))
      })
      .catch(e => {
        if (axios.isCancel(e)) {
          console.log('Request canceled')
        } else {
          dispatch(changePaymentLoading(false))

          switch (e.response.status) {
            case 401:
              dispatch(signOut())
              break
            default:
          }
        }
      })
  }
}
